// extracted by mini-css-extract-plugin
export var overview = "about-module--overview--7T9yK";
export var experience = "about-module--experience--tYa9R";
export var card = "about-module--card--KnNBX";
export var downloadButton = "about-module--downloadButton--2vE-B";